import React from 'react';
import { AvatarSmall, IconSpinner, NamedLink } from '../../components';
import ChipRail from './ChipRail/ChipRail';
import css from './SearchPage.module.css';

const UserSelector = ({
  intl,
  currentUser,
  connectedUsers,
  getConnectedUsersInProgress,
  userListingCounts,
  fetchUserListingCountsInProgress,
  history
}) => {
  const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams('');
  const selectedUserId = searchParams.get('selectedUserId');
  const searchType = searchParams.get('searchType');
  const stock = searchParams.get('stock');

  const isOwnListingSelected = searchType === 'ownListing';
  const isOutOfStockSelected = stock === 'no-stock';

  const showOutOfStockCheckboxLabel = intl.formatMessage({
    id: 'ShowOwnListings.showOutOfStockCheckboxLabel'
  });


  const isLoading = getConnectedUsersInProgress || fetchUserListingCountsInProgress;

  /* P25009-486 BR-1 — "Kris88 (Du) 0 annons" is a seller's shortcut, not
   * something a buyer looking for wheels needs: the own pill only shows when
   * this search holds the user's own listings, or while it is selected. */
  const ownListingCount = currentUser ? userListingCounts?.[currentUser.id?.uuid] || 0 : 0;
  const showOwnPill = !!currentUser && (ownListingCount > 0 || isOwnListingSelected);

  const handleSelectUser = userId => {
    searchParams.delete('searchType');

    if (userId) {
      if (userId === selectedUserId) {
        searchParams.delete('selectedUserId');
      } else {
        searchParams.set('selectedUserId', userId);
      }
    } else {
      if (isOwnListingSelected) {
        searchParams.delete('searchType');
      } else {
        searchParams.set('searchType', 'ownListing');
      }
      searchParams.delete('selectedUserId');
    }

    const updatedSelectedUserId = userId === selectedUserId ? null : userId;
    const isNowOwnListing = !userId && !isOwnListingSelected;

    if (!updatedSelectedUserId && !isNowOwnListing) {
      searchParams.delete('stock');
    }

    searchParams.set('page', 1);
    history.push(`?${searchParams.toString()}`);
  };


  const handleStockToggle = checked => {
    if (checked) {
      searchParams.set('stock', 'no-stock');
    } else {
      searchParams.delete('stock');
    }
    history.push(`?${searchParams.toString()}`);
  };

  return (
    <div className={css.modalBody}>
      {/* Seller pills in one fixed-height rail (P25009-453 BR-1); the rail
        * itself renders nothing when the visitor has no pills (BR-4). */}
      <ChipRail ariaLabel="Säljare" railHeight={64}>
        {/* Pill for current user */}
        {showOwnPill && (
          <button
            className={`${css.userPill} ${isOwnListingSelected ? css.selectedPill : ''}`}
            onClick={() => handleSelectUser(null)}
          >
            <AvatarSmall user={currentUser} disableProfileLink />
            <div className={css.pillText}>
              <div className={css.pillName}>
                {currentUser.attributes.profile.displayName} (Du)
              </div>
              <div className={css.pillCount}>
                {ownListingCount} annons{ownListingCount === 1 ? '' : 'er'}
              </div>
            </div>
          </button>
        )}

        {/* Pills for connected users */}
        {isLoading ? (
          <div className={css.iconSpinner}>
            <IconSpinner />
          </div>
        ) : connectedUsers && connectedUsers.length > 0 ? (
          connectedUsers.map((user, index) => {
            const userId = user.id?.uuid;
            const isSelected = userId === selectedUserId;
            const listingCount = userListingCounts?.[userId] || 0;

            return (
              <button
                key={index}
                className={`${css.userPill} ${isSelected ? css.selectedPill : ''}`}
                onClick={() => handleSelectUser(userId)}
              >
                <AvatarSmall user={user} disableProfileLink />
                <div className={css.pillText}>
                  <div className={css.pillName}>
                    {user?.attributes.profile?.displayName}
                  </div>
                  <div className={css.pillCount}>
                    {listingCount} annons{listingCount === 1 ? '' : 'er'}
                  </div>
                </div>
              </button>
            );
          })
        ) : null
        //  (
        //   <div className={css.noResultMessage}>
        //     <p>Inga anslutna användare för tillfället.</p>
        //     <NamedLink name="AccessRequestPage">klicka här för att ansluta</NamedLink>
        //   </div>
        // )
        }
      </ChipRail>

      {/* Show stock filter if any user is selected */}
      {(isOwnListingSelected || selectedUserId) && (
        <div style={{ paddingTop: '1rem' }}>
          <label className={css.stockCheckboxLabel}>
            <input
              type="checkbox"
              checked={isOutOfStockSelected}
              onChange={e => handleStockToggle(e.target.checked)}
            />
            <span>{showOutOfStockCheckboxLabel}</span>
          </label>
        </div>
      )}
    </div>
  );
};

export default UserSelector;
